import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-subscription-category-edit-dialog',
  templateUrl: './subscription-category-edit-dialog.component.html',
  styleUrls: ['./subscription-category-edit-dialog.component.css']
})
export class SubscriptionCategoryEditDialogComponent implements OnInit {
  id = null;
  oldName = null;
  subscriptionCategory = new FormGroup({
    name: new FormControl(),
    allowSendReceipt: new FormControl()
  });

  constructor(public dialogRef: MatDialogRef<SubscriptionCategoryEditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.category) {
      this.id = data.category.id;
      this.subscriptionCategory.patchValue(data.category);
      this.oldName = data.category.name;
    }
  }

  ngOnInit() {
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public submitDialog(remove): void {
    if (remove) {
      const result = this.subscriptionCategory.value;
      if (this.id) {
        result.id = this.id;
      }
      result.deleted = true;
      this.dialogRef.close(result);
    } else {
      const result = this.subscriptionCategory.value;
      if (this.id) {
        result.id = this.id;
      }
      this.dialogRef.close(result);
    }

    
  }

  isValid() {
    return this.subscriptionCategory.get('name').value;
  }
}
